import React from 'react';

export default class Input extends React.Component {
  componentDidUpdate(prevProps) {
    if (!prevProps.meta.active && this.props.meta.active) {
      this.input.focus();
    }
  }

  render() {
    let error;
    if (this.props.meta.touched && this.props.meta.error) {
      error = <section className="form-error">{this.props.meta.error}</section>;
    }

    let warning;
    if (this.props.meta.touched && this.props.meta.warning) {
      warning = <section className="form-warning">{this.props.meta.warning}</section>;
    }

    return (
      <section className="form-input">
        <label htmlFor={this.props.input.name}>
          {this.props.label}
          {error}
          {warning}
        </label>
        <input {...this.props.input} id={this.props.input.name} type={this.props.type} autoComplete="on"
          ref={input => (this.input = input)} />
      </section>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/input.js